export default ((node, props) => {
  var title = node.querySelector('[data-cms-title="Title"]').querySelector('p').outerHTML;
  return {
    title
  };
});